<template lang="html">
  <v-table
    class="accesses-table"
    :headers="headers"
    :items="list"
    :table-name="tableName"
    :loading="loading"
    @updateHeaders="updateHeaders"
  >
    <template #header="{ header }">
      <template v-if="header.id === 'checkbox'">
        <vchecklabel v-if="allowManage" v-model="isAllUsersSelected" />
      </template>

      <template v-else-if="header.id === 'vacancy'">
        <div>{{ $tr('common.list.name') }}</div>
      </template>

      <template v-else-if="header.id === 'rights'">
        <div>{{ $tr('common.list.rights') }}</div>
      </template>

      <template v-else-if="header.id === 'email'">
        <div>{{ $tr('common.list.email') }}</div>
      </template>

      <template v-else-if="header.id === 'phone'">
        <div>{{ $tr('common.list.phone') }}</div>
      </template>

      <template v-else-if="header.id === 'region'">
        <div>{{ $tr('common.list.region') }}</div>
      </template>
    </template>

    <template #cell="{ header, cell }">
      <user-row
        v-if="list.length"
        :model="cell"
        :header="header"
        :cell="cell"
        :permissions="permissions"
        :allow-manage="allowManage"
        :vacancy="vacancy"
        :list="list"
      />
    </template>
  </v-table>
</template>

<script>
  import UserRow from './Row';
  import VTable from '@/components/table';

  export default {
    name: 'PreferencesAccessesList',

    components: {
      UserRow,
      VTable
    },

    props: {
      list: Array,
      allowManage: Boolean,
      loading: Boolean
    },

    data() {
      return {
        tableName: 'vacancy-accesses',
        headers: [
          {
            id: 'checkbox',
            name: '',
            is_visible: true,
            is_base: true,
            width: ''
          },
          {
            id: 'vacancy',
            name: this.$tr('common.list.name'),
            is_visible: true,
            is_base: false,
            width: ''
          },
          {
            id: 'rights',
            name: this.$tr('common.list.rights'),
            is_visible: true,
            is_base: false,
            width: ''
          },
          {
            id: 'email',
            name: this.$tr('common.list.email'),
            is_visible: true,
            is_base: false,
            width: ''
          },
          {
            id: 'phone',
            name: this.$tr('common.list.phone'),
            is_visible: true,
            is_base: false,
            width: ''
          },
          {
            id: 'region',
            name: this.$tr('common.list.region'),
            is_visible: true,
            is_base: false,
            width: ''
          }
        ]
      };
    },

    computed: {
      permissions() {
        return this.$store.getters['dictionary/permissions'].map(({ id }) => {
          let role_name;

          if (id === 'admin') {
            role_name = this.$tr('permissions.roleAdmin');
          } else if (id === 'role_edit_scoring') {
            role_name = this.$tr('permissions.roleEdit');
          } else if (id === 'role_read') {
            role_name = this.$tr('permissions.roleRead');
          } else {
            role_name = '';
          }

          return {
            id,
            name: role_name,
            subname: this.$tr(`permissions.${id.replace(',', '_')}`)
          };
        });
      },

      selectedUsers() {
        return this.$store.getters['users/selectedUsers'];
      },

      isAllUsersSelected: {
        get() {
          return this.users.every(user => this.$store.getters['users/isSelected'](user));
        },

        set(state) {
          this.list.forEach(user => {
            if (user.permission !== 'admin') {
              this.$store.dispatch('users/setSelectedState', { model: user, state });
            }
          });
        }
      },

      selectedAdmins() {
        return this.list.filter(user => {
          if (user.permission !== 'admin') {
            return false;
          }
          return this.$store.getters['users/isSelected'](user);
        });
      },

      admins() {
        return this.list.filter(user => {
          return user.permission === 'admin';
        });
      },

      users() {
        return this.list.filter(user => user.permission !== 'admin');
      },

      leftOneAdmin() {
        return this.admins.length === 1;
      },

      vacancy() {
        return this.$store.getters['vacancy/one'];
      }
    },

    beforeDestroy() {
      this.reset_selected();
    },

    methods: {
      reset_selected() {
        this.$store.commit('users/resetSelected');
      },

      updateHeaders(headers) {
        this.headers.splice(0, this.headers.length, ...headers);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .accesses-table {
    table-layout: fixed;
    .column-checkbox {
      width: 60px;
      text-align: center;
    }

    .column-avatar {
      width: 8%;
    }

    .column-vacancy {
      width: 19%;
    }

    .column-rights {
      width: 178px;
    }

    .column-email {
      width: 108px;
    }

    .column-status {
      width: 13%;
    }

    .column-region {
      width: 19%;
    }
  }
</style>
